<label for="textarea_encuesta"><span>{{label}}</span></label>
<textarea [value]="value"
          (input)="onChange($event.target.value)"
          (blur)="onTouched()" 
          class="form-control shadow-none"
          id="textarea_encuesta" rows="5">
</textarea>

